module.exports = __webpack_public_path__ + "static/media/lock-open.e9e3e34b.svg";